import { useState } from 'react';

import { DisplayComponent } from '@/components/DisplayComponent';
import { DisplayHeading } from '@/components/DisplayHeading';
import { Header } from '@/components/Header';
import { ProgressBar } from '@/components/ProgressBar';
import { selectBusinessManualEntry } from '@/context/borrower';
import { useAppSelector } from '@/context/storeHooks';
import { BusinessIndustry } from '@/UserInput/BusinessIndustry';
import { BusinessManualLookup } from '@/UserInput/BusinessManualLookup';

import { BusinessButtons } from './BusinessButtons';
import { BusinessLookupSection } from './BusinessLookupSection';
import { BusinessManualSection } from './BusinessManualSection';

export const testId = 'Business';

export function Business(): JSX.Element {
    // ***** CONSTANTS *****p
    const baseId = 'screen-business';
    const [showErrors, setShowErrors] = useState<boolean>(false);
    const manualEntry = useAppSelector(selectBusinessManualEntry);
    const stateToShow = manualEntry === undefined ? true : manualEntry; // select business manual entry = false = use smart lookup true

    return (
        <div data-testid={testId}>
            <DisplayComponent baseId={baseId}>
                <Header />
            <ProgressBar />
            <DisplayHeading
                title='Business Details'
                infoText='We need some details about your business'
            />
            <BusinessIndustry baseId={baseId} showErrors={showErrors} />

            <BusinessManualLookup baseId={baseId} showErrors={showErrors} />
            {stateToShow ? (
                <BusinessLookupSection
                    baseId={baseId}
                    showErrors={showErrors}
                />
            ) : (
                <BusinessManualSection
                    baseId={baseId}
                    showErrors={showErrors}
                />
            )}
            <BusinessButtons baseId={baseId} setShowErrors={setShowErrors} />
            </DisplayComponent>
        </div>
    );
}
